(function () {
  'use strict';

  if (window.VCCFirstHeroPaint && window.VCCFirstHeroPaint.version === 1) return;

  var script = document.currentScript;
  var isHome = Boolean(script && script.dataset.vccHome === 'true');
  var resolveReady;
  var timeoutId = 0;
  var lcpObserver = null;
  var state = {
    version: 1,
    painted: false,
    detail: null,
    ready: new Promise(function (resolve) {
      resolveReady = resolve;
    }),
  };

  window.VCCFirstHeroPaint = state;
  window.__vccFirstHeroPainted = false;

  function finish(reason, hero, entry) {
    if (state.painted) return;
    state.painted = true;
    window.__vccFirstHeroPainted = true;
    document.documentElement.dataset.vccFirstHeroPainted = 'true';

    if (timeoutId) window.clearTimeout(timeoutId);
    if (lcpObserver) lcpObserver.disconnect();

    state.detail = {
      reason: reason,
      route: isHome ? 'home' : 'route',
      hero: hero || null,
      entry: entry || null,
      paintedAt: window.performance && performance.now ? performance.now() : Date.now(),
    };

    resolveReady(state.detail);
    document.dispatchEvent(new CustomEvent('vcc:first-hero-painted', { detail: state.detail }));
  }

  function afterPaintFrames(callback) {
    if (document.visibilityState === 'hidden' || typeof window.requestAnimationFrame !== 'function') {
      window.setTimeout(callback, 0);
      return;
    }

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(callback);
    });
  }

  function routeReady() {
    finish('route-ready', null, null);
  }

  if (!isHome) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', routeReady, { once: true });
    } else {
      window.queueMicrotask ? window.queueMicrotask(routeReady) : window.setTimeout(routeReady, 0);
    }
    return;
  }

  function startHomeGate() {
    var hero = document.querySelector('[data-vcc-first-hero-paint="true"]');
    if (!hero) {
      afterPaintFrames(function () { finish('home-no-hero', null, null); });
      return;
    }

    var image = hero.querySelector('[data-vcc-slide].is-active img, img.vcc-image-banner__image');

    if ('PerformanceObserver' in window) {
      try {
        var supported = PerformanceObserver.supportedEntryTypes || [];
        if (supported.indexOf('largest-contentful-paint') !== -1) {
          lcpObserver = new PerformanceObserver(function (list) {
            list.getEntries().forEach(function (entry) {
              if (state.painted) return;
              var element = entry.element;
              var expectedUrl = image ? (image.currentSrc || image.src || '') : '';
              var entryUrl = entry.url || '';
              var isExpectedElement = Boolean(element && (element === hero || hero.contains(element)));
              var isExpectedUrl = Boolean(expectedUrl && entryUrl && expectedUrl === entryUrl);
              if (isExpectedElement || isExpectedUrl) finish('lcp-observer', hero, entry);
            });
          });
          lcpObserver.observe({ type: 'largest-contentful-paint', buffered: true });
        }
      } catch (error) {
        lcpObserver = null;
      }
    }

    function settleAfterDecode(reason) {
      var decode = image && typeof image.decode === 'function'
        ? image.decode().catch(function () {})
        : Promise.resolve();

      decode.then(function () {
        afterPaintFrames(function () { finish(reason, hero, null); });
      });
    }

    if (!image) {
      afterPaintFrames(function () { finish('home-no-image', hero, null); });
    } else if (image.complete) {
      settleAfterDecode(image.naturalWidth > 0 ? 'decode-fallback' : 'image-error');
    } else {
      image.addEventListener('load', function () { settleAfterDecode('decode-fallback'); }, { once: true });
      image.addEventListener('error', function () {
        afterPaintFrames(function () { finish('image-error', hero, null); });
      }, { once: true });
    }

    timeoutId = window.setTimeout(function () {
      finish(document.visibilityState === 'hidden' ? 'hidden-timeout' : 'hero-timeout', hero, null);
    }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startHomeGate, { once: true });
  } else {
    startHomeGate();
  }
})();
